import { useState, useCallback } from "react";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";


export const useCombinationDetails = (actualSetLength) => {
    const [selectedCombination, setSelectedCombination] = useState(null);
    const [availableLot, setAvailableLot] = useState([]);
    const [selectedSetID, setSelectedSetID] = useState(null);
    const [combinationStatus, setCombinationStatus] = useState(false);
    const [isExtraSetModalOpen, setIsExtraSetModalOpen] = useState(false);
    const [loadingAvailableSets, setLoadingAvailableSets] = useState(false);
    const [errorAvailableSets, setErrorAvailableSets] = useState(null);

    /**
     * Load details for a particular MO/Lot combination
     */
    
    const getParticularCombinationDetails = useCallback(
        async (mo_number, lot_number, reel_length, { loadMADetails, setPlanningDetail }) => {
            setLoadingAvailableSets(true);
            setErrorAvailableSets(null);

            try {
                //PARAMETER
                const para = {
                    p_companyid: localStorage.getItem("companyid"),
                    p_plantid: 1,
                    p_release_no: mo_number,
                    p_lot_no: lot_number,
                };

                // 1. Get combination details
                const data = await callApi(
                    API_ENDPOINTS.PROD_MANAGEMENT_GET_COMBINATION_DETAILS,
                    "POST",
                    { "Content-Type": "application/json" },
                    para
                );

                if (data && data.length > 0) {
                    setSelectedCombination(data);

                    // 2. Get processed sets
                    const setList = await callApi(
                        API_ENDPOINTS.PROD_MANAGEMENT_GET_PROCESSED_SETS,
                        "POST",
                        { "Content-Type": "application/json" },
                        para
                    );

                    let templist = [];
                    const setcount = data[0].sets;

                    // populate all sets
                    for (let i = 1; i <= setcount; i++) {
                        templist.push({ set_id: i });
                    }

                    if (setList && setList.length > 0) {
                        // filter out already processed sets
                        const setListIds = new Set(setList.map((item) => item.sets));
                        templist = templist.filter((item) => !setListIds.has(item.set_id));
                    }

                    setAvailableLot(templist);
                    setSelectedSetID(templist[0]);

                    if (templist.length > 0) {
                        if (actualSetLength === 0 || reel_length === 0) {
                            setCombinationStatus(false);
                        } else {
                            setCombinationStatus(true);
                        }
                        setIsExtraSetModalOpen(false);
                    } else {
                        // All sets processed
                        loadMADetails?.();
                        if (reel_length > 0) {
                            setIsExtraSetModalOpen(true);
                        } else {
                            setCombinationStatus(false);
                        }
                    }
                }
            } catch (err) {
                console.error("Error fetching combination details:", err);
                setErrorAvailableSets(err);
            } finally {
                setLoadingAvailableSets(false);
                setPlanningDetail?.(false); // mimic setviewWinderParentRollPlanningDetail(false)
            }
        },
        [actualSetLength]
    );

    return {
        selectedCombination,
        availableLot,
        selectedSetID,
        combinationStatus,
        isExtraSetModalOpen,
        loadingAvailableSets,
        errorAvailableSets,
        getParticularCombinationDetails,
        setSelectedSetID,
        setCombinationStatus,
        setIsExtraSetModalOpen,
    };
};
